<template>
	<div class="mouth" :style="position">
		<svg
			class="mouth__inner"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 136 62"
		>
			<defs>
				<clipPath id="mouth-3a">
					<path
						d="M68 34.5c-37.233-.035-60-.065-60-10.59C8 11.327 35.119 15 68 15s60-3.672 60 8.911c0 10.524-22.767 10.554-60 10.589z"
						fill="none"
					/>
				</clipPath>
				<clipPath id="mouth-3b">
					<path
						d="M68 26.9c-37.233-.039-60 7.535-60-2.99C8 11.327 35.119 15 68 15s60-3.672 60 8.911c0 10.524-22.767 2.95-60 2.989z"
						fill="none"
					/>
				</clipPath>
				<clipPath id="mouth-2">
					<circle cx="68" cy="31" r="25" fill="none" />
				</clipPath>
				<clipPath id="mouth-1">
					<path
						d="M68 14.994c32.881 0 60-5 60 7.449 0 5.488-22.767 13.522-60 13.557-37.233-.035-60-8.069-60-13.557 0-12.454 27.119-7.449 60-7.449z"
						fill="none"
					/>
				</clipPath>
				<clipPath id="mouth-0">
					<path
						d="M67.866 62C25.751 61.951 0 29.445 0 11.9S30.675 1.4 67.866 1.4 136-5.653 136 11.9c0 17.49-28.97 50.145-68.134 50.1z"
						fill="none"
					/>
				</clipPath>
				<image
					id="mouth-teeth"
					width="110"
					height="69"
					xlink:href="data:image/png;base64,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"
				/>
			</defs>
			<g v-if="index === 3">
				<g clip-path="url(#mouth-3a)">
					<g clip-path="url(#mouth-3b)">
						<path
							d="M68 26.9c-37.233-.039-60 7.535-60-2.99C8 11.327 35.119 15 68 15s60-3.672 60 8.911c0 10.524-22.767 2.95-60 2.989z"
							fill="#14335f"
						/>
						<path
							d="M68 27.269c-35.562-.031-57.306 6.461-57.306-2.56 0-10.784 25.9-7.638 57.306-7.638s57.306-3.146 57.306 7.638c0 9.021-21.744 2.529-57.306 2.56z"
							fill="#0a3768"
						/>
						<path
							d="M68 27.641c-34.033-.025-54.843 5.383-54.843-2.133 0-8.984 24.788-6.363 54.843-6.363s54.843-2.621 54.843 6.363c0 7.516-20.81 2.108-54.843 2.133z"
							fill="#003b71"
						/>
					</g>
					<use
						transform="matrix(.431 0 0 .432 16.177 3.009)"
						xlink:href="#mouth-teeth"
						style="isolation:isolate"
						opacity=".75"
					/>
					<path
						d="M42.259 6.558a156.732 156.732 0 01-24.892-2.383c1.9 15.358 7.409 26.475 13.919 26.475 6.177 0 11.449-10.013 13.6-24.152-.876.036-1.748.06-2.627.06z"
						fill="#fff"
					/>
					<path
						d="M36.626 10.864c-.41 0-.814-.014-1.221-.018 2.561 11.087 7.2 18.526 12.521 18.526 5.854 0 10.9-9.013 13.234-22a100.478 100.478 0 01-24.534 3.492z"
						fill="#fff"
					/>
				</g>
			</g>
			<g v-else-if="index === 2">
				<g clip-path="url(#mouth-2)">
					<path fill="#14335f" d="M43 6h50v50H43z" />
					<circle cx="68" cy="32.024" r="23.976" fill="#0a3768" />
					<circle cx="68" cy="33.049" r="22.951" fill="#003b71" />
					<use
						transform="matrix(.431 0 0 .432 19.5 -6.5)"
						xlink:href="#mouth-teeth"
						style="isolation:isolate"
						opacity=".75"
					/>
					<path
						d="M45.582-2.951A156.955 156.955 0 0120.69-5.334c1.9 15.357 7.409 26.475 13.919 26.475 6.177 0 11.448-10.013 13.594-24.152a65.1 65.1 0 01-2.621.06z"
						fill="#fff"
					/>
					<path
						d="M39.948 1.354c-.409 0-.813-.013-1.22-.018 2.56 11.088 7.2 18.527 12.521 18.527 5.853 0 10.9-9.014 13.234-22a100.383 100.383 0 01-24.535 3.491z"
						fill="#fff"
					/>
					<path fill="none" d="M65.535 8.049h4.93v2.049h-4.93z" />
				</g>
			</g>
			<g v-else-if="index === 1">
				<g clip-path="url(#mouth-1)">
					<path fill="#14335f" d="M8 14h120v22H8z" />
					<path
						d="M68 17.045c31.458 0 57.4-4.516 57.4 6.722 0 4.952-21.782 12.2-57.4 12.233-35.622-.032-57.4-7.281-57.4-12.233 0-11.238 25.942-6.722 57.4-6.722z"
						fill="#0a3768"
					/>
					<path
						d="M68 19.1c30 0 54.747-4.026 54.747 5.994 0 4.414-20.773 10.878-54.747 10.906-33.974-.028-54.747-6.492-54.747-10.907C13.253 15.073 38 19.1 68 19.1z"
						fill="#003b71"
					/>
					<use
						transform="matrix(.431 0 0 .432 16.177 .097)"
						xlink:href="#mouth-teeth"
						style="isolation:isolate"
						opacity=".75"
					/>
					<path
						d="M42.259 3.645a156.732 156.732 0 01-24.892-2.383c1.9 15.358 7.409 26.475 13.919 26.475 6.177 0 11.449-10.013 13.6-24.151-.876.035-1.748.059-2.627.059z"
						fill="#fff"
					/>
					<path
						d="M36.626 7.951c-.41 0-.814-.013-1.221-.018 2.561 11.087 7.2 18.527 12.521 18.527 5.854 0 10.9-9.014 13.234-22a100.478 100.478 0 01-24.534 3.491z"
						fill="#fff"
					/>
				</g>
			</g>
			<g v-else>
				<g clip-path="url(#mouth-0)">
					<path fill="#14335f" d="M0 0h136v62H0z" />
					<path
						data-name="Path 118"
						d="M67.87 62C27.181 61.953 2.3 30.546 2.3 13.59S31.938 3.45 67.87 3.45s65.83-6.82 65.83 10.14c0 16.902-27.991 48.454-65.83 48.41z"
						fill="#0a3768"
					/>
					<path
						data-name="Path 119"
						d="M67.874 62C28.609 61.954 4.6 31.647 4.6 15.285S33.2 5.5 67.874 5.5 131.4-1.078 131.4 15.285c0 16.309-27.011 46.758-63.526 46.715z"
						fill="#003b71"
					/>
					<use
						transform="matrix(.431 0 0 .432 16.177 -10.096)"
						xlink:href="#mouth-teeth"
						style="isolation:isolate"
						opacity=".75"
					/>
					<path
						d="M42.259-6.547A156.966 156.966 0 0117.367-8.93c1.9 15.357 7.409 26.475 13.919 26.475 6.177 0 11.449-10.013 13.6-24.152-.876.035-1.748.06-2.627.06z"
						fill="#fff"
					/>
					<path
						d="M36.626-2.242c-.41 0-.814-.013-1.221-.018 2.561 11.087 7.2 18.527 12.521 18.527 5.854 0 10.9-9.014 13.234-22a100.43 100.43 0 01-24.534 3.491z"
						fill="#fff"
					/>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
import xyPos from '@/mixins/xyPos'

// Array of all mouth states
const INDEXES = [0, 1, 2, 3]
const STATES = {
	wide: 0,
	smile: 1,
	shock: 2,
	closed: 3
}

// Frames between each mouth state change
const TALK_SPD = 10

export default {
	name: 'Mouth',
	data() {
		return {
			talking: false,
			index: 0,
			step: 0
		}
	},
	tick() {
		if (!this.talking) return false

		// Randomly pick a mouth state
		if (this.step === 0) {
			const options = INDEXES.filter(i => i !== this.index)
			const choice = Math.floor(Math.random() * options.length)
			this.index = options[choice]
		}

		// Increment step
		this.step = (this.step + 1) % TALK_SPD
	},
	methods: {
		talk() {
			this.talking = true
		},
		set(state) {
			this.reset()
			this.index = STATES[state] || 0
		},
		reset() {
			this.talking = false
			this.index = 0
			this.step = 0
		}
	},
	mixins: [xyPos]
}
</script>

<style lang="scss" scoped>
.mouth {
	position: absolute;
	width: 0;
	height: 0;

	&__inner {
		position: absolute;
		top: 0;
		left: 0;
		width: 8.5em;
		height: 3.875em;
		transform: translate3d(-50%, -50%, 0);
	}
}
</style>
